import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import PageEditor from "../PageEditor/PageEditor";
import "./HandPrint.css";
import mixins from "../../app-services/mixins";
import { readUrl } from "../PageEditor/support";
import { staticPages, pageStyle, getPages } from "./handprintConfig";
import PreInfoColletion from "./Preinfo";
import { withRouter } from "../../app-services/lib/router-compat";
import { Button } from "@mui/material";
import uploadplaceholder from "./uploadPlaceholder.png";
import { replaceHandprintBgImages } from "./images";

export function HandPrint(props) {
  const BOOKID = props.match.params.id;
  const book = props.store?.book?.customCharacter;
  const pageeditorref = useRef(null);
  const selfRef = useRef(null);
  if (!selfRef.current) {
    selfRef.current = {};
  }
  const self = selfRef.current;
  self.BOOKID = BOOKID;
  self.pageeditorref = pageeditorref;
  self.props = props;

  const [state, setStateRaw] = useState(() => ({
    pageStyle,
    staticPages,
    savedBook: {},
    bolierplates: {},
    svgs: {},
    pages: getPages(book),
    overlayStyle: {},
  }));

  self.state = state;
  self.setState = (update, callback) => {
    setStateRaw((prev) => {
      const next = typeof update === "function" ? update(prev) : { ...prev, ...update };
      return next;
    });
    if (callback) setTimeout(callback, 0);
  };

  useLayoutEffect(() => {
    initialConstruct.bind(self)("HandPrint", props);
  }, []);

  self.getContent = (book, page) => {
    let ele = mixins.getDataNode(replaceHandprintBgImages(book));
    const handprintPreInfo = self.props.store?.book?.handprintPreInfo;
    const answer = handprintPreInfo?.answer;
    const handprints = handprintPreInfo?.handprints;
    if (page.assetname && handprints?.[page.assetname]) {
      let imgEle = ele.querySelector("#image-element");
      imgEle.src = handprints[page.assetname].filepath;
    }
    let child_name = ele.querySelector("#child_name");
    if (child_name && answer && answer.child_name) {
      child_name.innerText = answer.child_name;
    }
    let dedictaion_text = ele.querySelector("#dedictaion_text");
    if (dedictaion_text && answer && answer.dedication) {
      dedictaion_text.innerText = answer.dedication;
    }
    let adult_name = ele.querySelector("#adult_name");
    if (adult_name && answer && answer.parent_name) {
      adult_name.innerText = answer.parent_name;
    }
    book = ele.innerHTML;
    return book;
  };

  self.getLatestBook = () => {
    const handprintPreInfo = self.props.store?.book?.handprintPreInfo;
    return new Promise((resolve, reject) => {
      api
        .getUpdatedSelfBook({
          sessionId: localStorage.getItem("sessionID") || null,
          type: "handprint",
        })
        .then((responce) => {
          if (responce && responce.data) {
            let payload = responce.data;
            let remoteHadprintAttributes = JSON.parse(
              payload.attributes || "{}"
            );
            self.setStore("book.handprintPreInfo", {
              ...handprintPreInfo,
              ...remoteHadprintAttributes,
            });
            self.setState((prev) => ({
              ...prev,
              savedBook: payload,
            }));
            setTimeout(() => {
              resolve(payload);
            });
          } else {
            resolve(self.state.savedBook);
          }
        })
        .catch(reject);
    });
  };

  self.updateBook = async (payload) => {
    const { savedBook } = self.state;
    const saveBOOKID = self.BOOKID;
    const handprintPreInfo = self.props.store?.book?.handprintPreInfo;
    if (savedBook && savedBook.id) {
      await api.updateSelfPublish(
        {
          bookId: saveBOOKID,
          savedBook: JSON.stringify(payload),
          option: "dynamic",
          sessionId: localStorage.getItem("sessionID") || null,
          type: "handprint",
          attributes: JSON.stringify(handprintPreInfo),
        },
        savedBook.id
      );
    } else {
      // This runs whenever HandprintView's "Add to cart" saves the book
      // before adding it (emit.trigger("updatebook", ...)) — for a book
      // that's never been explicitly saved yet, savedBook.id is undefined,
      // and posting to /api/selfPublishing/update/undefined just fails.
      // Create it instead, same as self.onSave's create branch does.
      const responce = await api.createSelfPublish({
        bookId: saveBOOKID,
        savedBook: JSON.stringify(payload),
        option: "dynamic",
        sessionId: localStorage.getItem("sessionID") || null,
        file: null,
        type: "handprint",
        attributes: JSON.stringify(handprintPreInfo),
      });
      const newBookId = responce?.data?.id;
      if (!newBookId) return null;
      // Keep the URL in sync so a second save in this session takes the
      // update branch above instead of creating a duplicate book — same
      // push self.onSave's create branch already does below. Purely
      // cosmetic/for-later here though: it does NOT make the newly
      // created book fetchable yet (see next comment), since useParams()
      // won't reflect it until React actually re-renders from this
      // navigation.
      self.history.push(
        self.history.location.pathname + `/${newBookId}`
      );
      // Deliberately NOT using self.getLatestBook() here: it resolves the
      // record via the URL's customBookId route param (see
      // api.getUpdatedSelfBook -> window.PageEditor.props.match.params),
      // which races the history.push above — that param won't update
      // until React re-renders, so calling it synchronously right after
      // push still finds no customBookId and returns {data: null}, same
      // failure as not pushing at all. Fetch the book directly by the id
      // the create call just returned instead, sidestepping that race.
      const fresh = await api.getSelfPublish(newBookId);
      if (fresh?.data) {
        let remoteHadprintAttributes = JSON.parse(fresh.data.attributes || "{}");
        self.setStore("book.handprintPreInfo", {
          ...handprintPreInfo,
          ...remoteHadprintAttributes,
        });
        self.setState((prev) => ({
          ...prev,
          savedBook: fresh.data,
        }));
        return fresh.data;
      }
      return null;
    }
  };

  self.onSave = (payload, saveSelf) => {
    const saveBOOKID = saveSelf.BOOKID;
    const { savedBook } = saveSelf.state;
    return new Promise((resolve, reject) => {
      mixins.checkLogin(saveSelf.history).then(() => {
        if (savedBook && savedBook.id) {
          saveSelf.updateBook(payload).then((responce) => {
            saveSelf
              .getLatestBook()
              .then((responce) => {
                resolve(responce);
              })
              .catch(reject);
          });
        } else {
          const handprintPreInfo = saveSelf.props.store?.book?.handprintPreInfo;
          api
            .createSelfPublish({
              bookId: saveBOOKID,
              savedBook: JSON.stringify(payload),
              option: "dynamic",
              sessionId: localStorage.getItem("sessionID") || null,
              file: null,
              type: "handprint",
              attributes: JSON.stringify(handprintPreInfo),
            })
            .then((responce) => {
              saveSelf.history.push(
                saveSelf.history.location.pathname + `/${responce.data.id}`
              );
              setTimeout(() => {
                saveSelf
                  .getLatestBook("createmsg")
                  .then((responce) => {
                    resolve(responce);
                  })
                  .catch(reject);
              });
            });
        }
      });
    });
  };

  self.onUpdate = () => {};

  self.updateBoilerplate = () => {
    return new Promise((resolve, reject) => {
      let { staticPages } = self.state;
      let promises = Object.entries(staticPages).map(([key, url]) => {
        return new Promise((resolve, reject) => {
          readUrl(url)
            .then((responce) => resolve({ key, responce: replaceHandprintBgImages(responce) }))
            .catch(reject);
        });
      });
      Promise.all(promises)
        .then((responce) => {
          let bolierplates = responce.reduce(
            (o, n) => ({ ...o, [n.key]: n.responce }),
            {}
          );
          resolve(bolierplates);
        })
        .catch(reject);
    });
  };

  self.onProceed = (...arg) => {
    self.uploadHanprints(...arg).then(() => {
      setTimeout(() => {
        self.pageeditorref.current?.querySelector("#previewBook")?.click();
      }, 150);
    });
  };

  self.updateChanges = (payload, modal) => {
    const handprintPreInfo = self.props.store?.book?.handprintPreInfo;
    let preInfo = handprintPreInfo || {};
    preInfo.answer = payload;
    preInfo.answer = payload;
    self.setStore("book.handprintPreInfo", preInfo);
    modal && modal.close();
    setTimeout(() => {
      self.updateData();
    }, 0);
  };

  self.uploadHanprints = (payload, modal) => {
    return new Promise((resolve, reject) => {
      const handprintPreInfo = self.props.store?.book?.handprintPreInfo;
      let preInfo = handprintPreInfo || {};
      if (
        payload.child_handprint instanceof File ||
        payload.parent_handprint instanceof File
      ) {
        const formData = new FormData();
        formData.append("child", payload.child_handprint);
        formData.append("adult", payload.parent_handprint);
        api
          .uploadHandprint(formData)
          .then((responce) => {
            if (responce && responce.statusCode === 200) {
              preInfo.handprints = Object.map(responce.data, (o) => ({
                ...o,
                filepath: "data:image/png;base64," + o.image_base64,
              }));
              preInfo.folder = responce.folder;
              // The raw File objects have already done their job (they were
              // just sent via formData above); they must not be persisted
              // into `answer`, since it later gets JSON.stringify'd for the
              // save payload — a File has no own enumerable properties, so
              // it silently serializes to "{}" instead of the actual upload.
              // Keep them truthy (the "Finish" button and the upload-badge
              // both just check truthiness) without keeping the File itself.
              preInfo.answer = {
                ...payload,
                child_handprint: true,
                parent_handprint: true,
              };
              self.setStore("book.handprintPreInfo", preInfo);
              modal && modal.close();
              self.updateData().then(resolve).catch(reject);
            } else {
              alert(responce.msg);
              reject(responce.msg);
            }
          })
          .catch(reject);
      } else {
        preInfo.answer = payload;
        self.setStore("book.handprintPreInfo", preInfo);
        modal && modal.close();
        setTimeout(() => {
          self.updateData().then(resolve).catch(reject);
        }, 0);
      }
    });
  };

  self.collectInfo = (closable = false) => {
    let onChange = (answer) => {};
    let modal = alert(
      (alertProps) => (
        <PreInfoColletion
          closable={closable}
          alert={alertProps}
          id={self.BOOKID}
          onChange={(...arg) => onChange(...arg)}
          onSave={(...arg) => self.onProceed(...arg)}
          onClose={(...arg) => self.onProceed(...arg)}
        />
      ),
      "",
      "model",
      {
        footer: false,
        class: "",
        parentclass: "HandPrint",
        options: {},
      }
    );
  };

  self.updateData = () => {
    return new Promise((resolve, reject) => {
      let { savedBook } = self.state;
      self.updateBoilerplate()
        .then((bolierplates) => {
          let book = savedBook?.savedBook?.parse({}) || {};
          let pages = self.state.pages.map((o) => ({
            ...o,
            content: self.getContent(
              book[o.name] || o.content || bolierplates[o.name] || "",
              o
            ),
          }));
          self.setState((prev) => ({
            ...prev,
            bolierplates: bolierplates,
            pages,
          }));
          resolve(pages);
        })
        .catch(reject);
    });
  };

  self.prepareForCollection = () => {
    let {
      match: {
        params: { genpdf, customBookId },
      },
    } = self.props;
    const handprintPreInfo = self.props.store?.book?.handprintPreInfo;
    const handprints = handprintPreInfo?.handprints;
    if (
      !handprintPreInfo ||
      !handprints ||
      (handprints && Object.keys(handprints).length <= 0 && !customBookId)
    ) {
      self.collectInfo();
    } else {
      self.updateData().then(() => {
        setTimeout(() => {
          self.pageeditorref.current?.querySelector("#previewBook")?.click();
        }, 150);
      });
    }
  };

  self.RightChildren = (childSelf) => {
    return () => (
      <Button
        className="edit"
        variant="outlined"
        id="editBook"
        onClick={() => childSelf.collectInfo(true)}
      >
        <i className="fa fa-edit"></i>
        <small>Edit</small>
      </Button>
    );
  };

  self.getNoticeMeesage = () => {
    let defaultmessage = "";
    let device = self.$store?.device;
    if (["mob", "small", "tab", "lap"].includes(device)) {
      defaultmessage +=
        "<br/><span style='font-size:12px; color:#cc3300; font-weight:400;'>Books Best view in Desktop version only</span>";
    }
    return defaultmessage;
  };

  self.onPreviewClose = (alertInstance) => {
    alertInstance.close();
  };

  useEffect(() => {
    emit.on("updatebook", async (...arg) => await self.updateBook(...arg));
    self.getLatestBook()
      .then(() => {
        self.prepareForCollection();
      })
      .catch(() => {
        self.prepareForCollection();
      });
    return () => {
      emit.remove("updatebook");
    };
  }, []);

  let noticeMessage = self.getNoticeMeesage();
  const { savedBook, pages, overlayStyle, pageStyle: statePageStyle } = state;
  const { onSave, RightChildren } = self;

  return (
    <div className="HandPrint top-margin" ref={pageeditorref}>
      <PageEditor
        pagePayload={pages}
        onSave={(...arg) => onSave(...arg, self)}
        charcount={100}
        lastPageNo={31}
        overlay={true}
        style={overlayStyle}
        leftTool={false}
        readonly={true}
        editbackground={false}
        RightChildren={RightChildren(self)}
        showCount={false}
        pageBordered={false}
        pageStyle={statePageStyle}
        uploadplaceholder={uploadplaceholder}
        nextmode={true}
        bookDetails={savedBook}
        message={noticeMessage}
        closablePreview={false}
        onPreviewClose={(...arg) => self.onPreviewClose(...arg)}
      ></PageEditor>
    </div>
  );
}

export default connect(withRouter(HandPrint));
